export const CustomerListSuccess = 'CUSTOMER_LIST_SUCCESS';
export const CustomerDetailsSuccess = 'CUSTOMER_DETAILS_SUCCESS';
export const CustomerUnitDetailsSuccess = 'CUSTOMER_UNIT_DETAILS_SUCCESS';
export const CustomerGetFilterSuccess = 'CUSTOMER_GET_FILTER_SUCCESS';

export function setCustomerListListAction(data) {
  return {
    type: CustomerListSuccess,
    payload: data,
  };
}

export function setCustomerDetailsAction(data) {
  return {
    type: CustomerDetailsSuccess,
    payload: data,
  };
}

export function setCustomerUnitDetailsAction(data) {
  return {
    type: CustomerUnitDetailsSuccess,
    payload: data,
  };
}

export function setCustomerFilterAction(data) {
  return {
    type: CustomerGetFilterSuccess,
    payload: data,
  };
}
